import { LikeIconSolid } from "../../../assets/icons";
import Modal from "../../Modal"

const AttributionsModal = ({setModalVisible}: {setModalVisible: (prev: boolean) => void}) => {
  return (
    <Modal
      controls
      modalTitle={"Attributions"}
      scroll
      setModalVisible={setModalVisible}
    >
      <div className="item-list xl-gap">
        <div className="item-row tile secondary padding-small" data-small={true}>
          <div className="icon-display secondary small">
            <LikeIconSolid />
          </div>
          <p className="body">All of the assets that I couldn't create myself are thanks to the great people below.</p>
        </div>
        <div className="item-list large-gap">
          <p className="heading-small">3D Assets</p>
          <div className="item-list small-gap">
            <div className="item-row">
              <p className="body">All Characters</p>
              <a className="link" href={"https://www.micaelsampaio.com/"} target={"_blank"}>Micael Sampaio</a>
            </div>
            <p className="secondary subheading-small weight-light">Please note that additional texture/skin colourations were done by me.</p>
          </div>
          <div className="item-row">
            <p className="body">Village Scene</p>
            <a className="link" href={"https://sketchfab.com/ion_omat"} target={"_blank"}>ion_omat</a>
          </div>
          <div className="item-row">
            <p className="body">Game Table</p>
            <a className="link" href={"https://sketchfab.com/vovaustimuk"} target={"_blank"}>vUv</a>
          </div>
        </div>
        <div className="item-list large-gap">
          <p className="heading-small">Full Accreditations</p>
          <p className="subheading-medium secondary">This work is based on "Low poly sunny girl" 
            (<a href={"https://sketchfab.com/3d-models/low-poly-sunny-girl-54d5bb15b9274cc2bdce1f401f101557"}>https://sketchfab.com/3d-models/low-poly-sunny-girl-54d5bb15b9274cc2bdce1f401f101557</a>)
             by micaelsampaio 
             (<a href={"https://sketchfab.com/micaelsampaio"}>https://sketchfab.com/micaelsampaio</a>)
              licensed under CC-BY-4.0 
              (<a href={"http://creativecommons.org/licenses/by/4.0/"}>http://creativecommons.org/licenses/by/4.0/</a>)
          </p>
          <p className="subheading-medium secondary">This work is based on "Stylized Low Poly Girl Character" 
            (<a href={"https://sketchfab.com/3d-models/stylized-low-poly-girl-character-c77426c4db8b459bb8ecb2afed6a2fbc"}>https://sketchfab.com/3d-models/stylized-low-poly-girl-character-c77426c4db8b459bb8ecb2afed6a2fbc</a>)
             by micaelsampaio 
             (<a href={"https://sketchfab.com/micaelsampaio"}>https://sketchfab.com/micaelsampaio</a>)
              licensed under CC-BY-4.0 
              (<a href={"http://creativecommons.org/licenses/by/4.0/"}>http://creativecommons.org/licenses/by/4.0/</a>)
          </p>
          <p className="subheading-medium secondary">This work is based on "Low Poly Flat Color Characters (M&F)" 
            (<a href={"https://sketchfab.com/3d-models/low-poly-flat-color-characters-mf-6cf71efd2ef8470d99e4132ba46d1df7"}>https://sketchfab.com/3d-models/low-poly-flat-color-characters-mf-6cf71efd2ef8470d99e4132ba46d1df7</a>)
             by micaelsampaio 
             (<a href={"https://sketchfab.com/micaelsampaio"}>https://sketchfab.com/micaelsampaio</a>)
              licensed under CC-BY-4.0 
              (<a href={"http://creativecommons.org/licenses/by/4.0/"}>http://creativecommons.org/licenses/by/4.0/</a>)
          </p>
          <p className="subheading-medium secondary">This work is based on "Low Poly Mini Village" 
            (<a href={"https://sketchfab.com/3d-models/low-poly-mini-village-8a512d2ca3d546319bbc7aaa696faa45"}>https://sketchfab.com/3d-models/low-poly-mini-village-8a512d2ca3d546319bbc7aaa696faa45</a>)
             by ion_omat 
             (<a href={"https://sketchfab.com/ion_omat"}>https://sketchfab.com/ion_omat</a>)
              licensed under CC-BY-4.0 
              (<a href={"http://creativecommons.org/licenses/by/4.0/"}>http://creativecommons.org/licenses/by/4.0/</a>)
          </p>
          <p className="subheading-medium secondary">This work is based on "TABLE" 
            (<a href={"https://sketchfab.com/3d-models/table-0a52fe2705144e57a148c9c6230d34fb"}>https://sketchfab.com/3d-models/table-0a52fe2705144e57a148c9c6230d34fb</a>)
             by vUv 
             (<a href={"https://sketchfab.com/vovaustimuk"}>https://sketchfab.com/vovaustimuk</a>)
              licensed under CC-BY-4.0 
              (<a href={"http://creativecommons.org/licenses/by/4.0/"}>http://creativecommons.org/licenses/by/4.0/</a>)
          </p>
        </div>
      </div>
    </Modal>
  )
}
export default AttributionsModal;